<template>
  <div
    ref="photoWindow"
    :style="{ height: photoWindowHeight }"
  >
    <img
      :src="photo ? photo : defaultImage"
      alt="Company Photo"
      class="d-block image-card-photo"
    >
  </div>
</template>

<script>
export default {
  props: {
    photo: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      defaultImage: require("../../../../assets/images/default_banner.png"),
      innerWidth: window.innerWidth,
      photoWindowHeight: 0,
    };
  },
  watch: {
    innerWidth() {
      this.calcWindowHeight();
    }
  },
  mounted() {
    window.addEventListener("resize", () => (this.innerWidth = window.innerWidth));
    this.calcWindowHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize");
  },
  methods: {
    calcWindowHeight() {
      this.photoWindowHeight = `${this.$refs.photoWindow.clientWidth * 0.421}px`;
    }
  }
};
</script>

<style lang="scss" scoped>
.image-card-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
